import { useState, useEffect } from 'react';

/**
 * 响应式 hooks，用于监听窗口大小变化
 * @param breakpoint 断点值，默认为 453
 * @returns 是否小于断点值
 */
export const useResponsive = (breakpoint: number = 453) => {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(false);

  useEffect(() => {
    const checkSize = () => {
      setIsBelowBreakpoint(window.innerWidth < breakpoint);
    };

    // 初始化检查
    checkSize();

    // 添加监听器
    window.addEventListener('resize', checkSize);

    // 清理监听器
    return () => window.removeEventListener('resize', checkSize);
  }, [breakpoint]);

  return isBelowBreakpoint;
};

/**
 * 专门用于 453px 断点的 hooks
 */
export const useBelow453 = () => useResponsive(453);

export const useResponsiveRadius = (
  factor: number = 1,
  maxInner: number = 35,
  maxOuter: number = 55
) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const calculateRadius = width => {
    let innerWidth = width * 0.06 * factor;
    let outerWidth = width * 0.1 * factor;
    if (innerWidth > maxInner) {
      innerWidth = maxInner;
    }
    if (outerWidth > maxOuter) {
      outerWidth = maxOuter;
    }
    return { inner: innerWidth, outer: outerWidth };
  };

  return calculateRadius(windowWidth);
};
